import type React from 'react';

export interface ModalFooterProps {
  children: React.ReactNode;
  className?: string;
  justify?: 'start' | 'center' | 'end' | 'between';
  background?: boolean;
}

const justifyClasses = {
  start: 'justify-start',
  center: 'justify-center', 
  end: 'justify-end',
  between: 'justify-between'
};

export const ModalFooter: React.FC<ModalFooterProps> = ({
  children,
  className = '',
  justify = 'between',
  background = true
}) => (
    <div 
      className={`
        flex items-center ${justifyClasses[justify]} p-6 border-t border-border-light
        ${background ? 'bg-bg-surface' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );

ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;